export default __webpack_public_path__ + "static/media/BluntStgNormalIcon.c6cb0018.png";